import React from 'react';
import RequestForm from './RequestForm';

const Edit = () => (
  <RequestForm />
);

export default Edit;
